module.exports = __webpack_public_path__ + "static/media/catalogueImg12.333df2be.png";